/** STAGE */
/**
 * 磊山前端內部負責專案
 * drew, bms, km, lab, 考照
 */
// const uris = {
//     /**
//      * 開發時需切換 BASE_URL 到自己本機開發環境，如不需看圖則不用切換
//      */
//     // BASE_URL: 'http://127.0.0.1:5501/src/' /** LOCAL */,
//     BASE_URL: 'https://bms-test.finext.app/webcomponent/',
//     SSO_URL: 'https://sso-test.ls-ecommerce.com.tw/',
//     /** 內部需SSO專案 */
//     BMS_URL: 'https://bms-test.finext.app/',
//     AWARD_URL: 'https://bms-test.finext.app/award/',
//     DREW_URL: 'https://drew-st.leishan.app/',
//     KM_URL: 'https://km.finext.app/',
//     LAB_URL: 'https://lab-test.ls-ecommerce.com.tw/',
//     CERTIFICATION_URL: 'https://certification-test.leishan.app/',

//     /** 需使用 function 帶 token 登入 */
//     PKS_URL: 'http://lsuat.mypks.net/',

//     /** 外包需SSO專案 */
//     EIP_URL: 'https://eip.leishan.com.tw:8080/LSLab/Default.aspx',
//     E_LEARNING_URL: 'https://elearning.leishan.app/cltcms/leishan_logout.jsp',

//     /** 其他系統 */
//     FINFO_URL: 'https://leishan.finfo.tw/agents/sign_in',
//     TIA_URL: 'https://lin.ee/a1Xku6q',
//     CTW_URL: 'https://lin.ee/hrggh9s',
//     OFFICIAL_URL: 'https://www.leishan.com.tw/',
// };
/** PRODUCTION */
const uris = {
    BASE_URL: 'https://bms.leishan.app/webcomponent/',
    SSO_URL: 'https://sso.ls-ecommerce.com.tw/',
    /** 內部需SSO專案 */
    BMS_URL: 'https://bms.leishan.app/',
    AWARD_URL: 'https://bms.leishan.app/award/',
    DREW_URL: 'http://drew.leishan.app',
    KM_URL: 'https://km.leishan.app/',
    LAB_URL: 'https://fee.ls-ecommerce.com.tw/',
    CERTIFICATION_URL: 'https://certification.leishan.app/',

    /** 需使用 function 帶 token 登入 */
    PKS_URL: 'https://eip.leishan.com.tw:8080/',

    /** 外包需SSO專案 */
    EIP_URL: 'https://eip.leishan.com.tw:8080/LSLab/Default.aspx',
    E_LEARNING_URL: 'https://elearning.leishan.app/cltcms/leishan_logout.jsp',

    /** 其他系統 */
    FINFO_URL: 'https://leishan.finfo.tw/agents/sign_in',
    TIA_URL: 'https://lin.ee/a1Xku6q',
    CTW_URL: 'https://lin.ee/hrggh9s',
    OFFICIAL_URL: 'https://www.leishan.com.tw/',
};

export { uris };
